module.exports = __webpack_public_path__ + "static/media/icita2002.70c1c174.png";